export const getRoutes = state => (state ? state.toJS() : null);

export const getRouteByFlight = (state, routeId) => state.find(route => route.id === routeId);



// WEBPACK FOOTER //
// ./src/redux/selectors/RoutesSelectors.js